module.exports = __webpack_public_path__ + "media/mypage/images/top/events_textbook_pc-351b5d3ef6764ecd88d56a7b413f3c95.png";